import React from 'react'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import { useNavigate } from 'react-router-dom'
import MediaWithShimmer from './MediaWithShimmer'

import black1 from '../imgs/black1.jpg'
import black2 from '../imgs/black2.jpg'

const BlackCoutureCollection = () => {
  const { language } = useLanguage()
  const t = translations.whiteCouture
  const navigate = useNavigate()

  const images = [black1, black2]

  return (
    <section className="bg-white cursor-pointer" onClick={() => navigate('/shop')}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 md:py-10 pt-0">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {images.map((src, index) => (
            <MediaWithShimmer
              key={index}
              src={src}
              alt={`Black Collection ${index + 1}`}
              wrapperClassName="h-[520px] md:h-[580px]"
              className="w-full object-cover rounded-xl shadow-md"
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default BlackCoutureCollection
